import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

const OBJECT_CATEGORY_OPTIONS = [
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.JAWERLY', value: 'JAWERLY', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.CLOCK', value: 'CLOCK', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GLASSES', value: 'GLASSES', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.FUR', value: 'FUR', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.PHOTO_VIDEO_PROFESSIONAL', value: 'PHOTO_VIDEO_PROFESSIONAL', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.PHOTO_VIDEO_PRIVATE', value: 'PHOTO_VIDEO_PRIVATE', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.HEARING_AID', value: 'HEARING_AID', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.INSTRUMENT_AND_MUSIC_SYSTEM', value: 'INSTRUMENT_AND_MUSIC_SYSTEM', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.FISHING_EQUIPMENT', value: 'FISHING_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.WEAPON', value: 'WEAPON', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GOLF_EQUIPMENT', value: 'GOLF_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.PC_EQUIPMENT_PRIVATE', value: 'PC_EQUIPMENT_PRIVATE', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.BUNAD_WITH_SILVER', value: 'BUNAD_WITH_SILVER', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.DIVING_EQUIPMENT', value: 'DIVING_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.PARACHUTE_PARAGLIDER_KITE', value: 'PARACHUTE_PARAGLIDER_KITE', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.SNOWBOARD_SNOWBOARDING', value: 'SNOWBOARD_SNOWBOARDING', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.OTHER_SKI_EQUIPMENT', value: 'OTHER_SKI_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.ANTIQUES', value: 'ANTIQUES', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.ELECTRIC_BICYCLE', value: 'ELECTRIC_BICYCLE', isListEmpty: true },
];

export const VALUABLES = {
  nickname: 'PRODUCTS.VALUABLES.shortname',
  properties: [
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^(?:[1-9]\d*)000$/)
      ]]
    },
    {
      name: 'objectCategory', key: 'OBJECT_CATEGORY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: OBJECT_CATEGORY_OPTIONS
      }
    },
  ],
  icon: 'valuables'
};
